module.exports = __webpack_public_path__ + "img/unreview.2df4987b.svg";